@if (globalFormError$ | async; as formError) { @if (formError.message && formError.fields) {
<ngb-alert dfInsertAlertIcon role="alert" class="df-page-alert alert-top-0 ps-8" type="danger" (closed)="closed()">
  <strong
    >{{formError.fields.length}}
    <ng-container i18n="@@newlogin.form.error"
      >{formError.fields.length, plural, =1 {Error} other {Errors}}</ng-container
    ></strong
  >
  - {{formError.message}}
  <ul class="m-0 ps-4">
    @for (field of formError.fields; track field) {
    <li>{{field}}</li>
    }
  </ul>
</ngb-alert>
} }
